export default "__VITE_ASSET__CTZFjJeV__"